"use client";

import { LinkExchangesList } from "./LinkExchangesList";
import { useOAuthSupportMap } from "@/hooks/exchangeAuthentication/useOAuthSupportMap";
import { cn } from "@/lib/utils";
import { useCreateAccountStore } from "@/store/accountStore";
import { STEPS, FLOW_TYPES, useConnectStore } from "@/store/connectStore";
import { getScrollbarClasses } from "@/styles/utils/scrollbarStyles.tailwind";

type ConnectExchangesProps = {
  exchangeIds: string[];
};

export function ConnectExchanges({ exchangeIds }: ConnectExchangesProps) {
  const { updateFormData } = useCreateAccountStore();
  const { setActiveStep, setOpenConnectModal, setExchangeIds, setFlowType } = useConnectStore();
  const oAuthSupportMap = useOAuthSupportMap();

  const handleSelectCex = (cex: string) => {
    updateFormData({ selectedCex: cex });
    setFlowType(FLOW_TYPES.READY_TO_USE);
    const step = oAuthSupportMap[cex] ? STEPS.LinkAccount : STEPS.ApiKeys;
    setActiveStep(step);
    setExchangeIds(exchangeIds);
    setOpenConnectModal(true);
  };

  return (
    <div className="w-full max-w-[500px] space-y-3">
      <h2 className="text-xl font-semibold text-cede-text-primary">Connect exchange</h2>
      <p className="text-sm text-cede-text-secondary">Be ready for the next epoch, link your account!</p>
      <div className={cn("max-h-[200px]", getScrollbarClasses())}>
        <LinkExchangesList
          exchangeIds={exchangeIds}
          handleSelectCex={handleSelectCex}
          showRemoveButton
          className="overflow-visible"
        />
      </div>
    </div>
  );
}
